export const ADD_NOTIFICATION_REQUEST = "notification/ADD_NOTIFICATION_REQUEST";
export const ADD_NOTIFICATION_SUCCESS = "notification/ADD_NOTIFICATION_SUCCESS";
export const ADD_NOTIFICATION_FAILURE = "notification/ADD_NOTIFICATION_FAILURE";

export const FETCH_NOTIFICATION_REQUEST = "notification/FETCH_NOTIFICATION_REQUEST";
export const FETCH_NOTIFICATION_SUCCESS = "notification/FETCH_NOTIFICATION_SUCCESS";
export const FETCH_NOTIFICATION_FAILURE = "notification/FETCH_NOTIFICATION_FAILURE";

export const UPDATE_NOTIFICATION_REQUEST = "notification/UPDATE_NOTIFICATION_REQUEST";
export const UPDATE_NOTIFICATION_SUCCESS = "notification/UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_FAILURE = "notification/UPDATE_NOTIFICATION_FAILURE";

export const FETCH_NOTIFICATION_COUNT_REQUEST = "notification/FETCH_NOTIFICATION_COUNT_REQUEST";
export const FETCH_NOTIFICATION_COUNT_SUCCESS = "notification/FETCH_NOTIFICATION_COUNT_SUCCESS";
export const FETCH_NOTIFICATION_COUNT_FAILURE = "notification/FETCH_NOTIFICATION_COUNT_FAILURE";

export const CLEAR_NOTIFICATION_VALUES = "notification/CLEAR_NOTIFICATION_VALUES";
export const RESET_NOTIFICATIONS_STATE = "notification/RESET_NOTIFICATIONS_STATE";